var env = require('environment');

var guestPaths = [
	'login','signup','forgot-password','logout','accounts/password/reset','join-call','invite', 'view-screen','troubleshoot','listen',
];

module.exports = angular.module('bbl.config', [])
	.constant('ENV', env)
	.constant('PUSHER_ID', env.PUSHER_ID)
	.constant('INTERCOM_ID', env.INTERCOM_ID)
	.constant('API', env.API_URLS)

	.constant('GUEST_ALLOW', guestPaths)
	.constant('IMPERSONATION', 'view-as')
	.constant('RTC_SIGNAL_HOST', env.RTC_SIGNAL_HOST)
	.constant('SLIDESHARE_SIGNAL_HOST', env.SLIDESHARE_SIGNAL_HOST)
	.constant('ICE_SERVERS', env.ICE_SERVERS)
;



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.config.js
 ** module id = 75
 ** module chunks = 0
 **/